module.exports = __webpack_public_path__ + "static/wireframe-8d6474205eb5b6ceed3aac719f1dc14e.png";